import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { StarOfDavid } from "./StarOfDavid";
import { SocialLinks } from "./SocialLinks";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { EditableText } from "@/components/site/edit/EditableText";

export function Footer() {
  const { t } = useLang();
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
  });
  const siteName = settings?.site_name?.trim() || "Chabad of Prague";
  const nav = settings?.nav_visibility || {};
  const vis = (id) => nav[id] !== false;
  return (
    <footer data-testid="site-footer" className="relative z-10 bg-[#0F172A] text-white/70 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 text-white">
              <span className="w-11 h-11 rounded-full bg-white flex items-center justify-center p-0.5"><img src="/logo.png" alt={`${siteName} logo`} className="w-full h-full object-contain" /></span>
              <span className="font-serif text-xl">{siteName}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed">
              <EditableText k="footer.tagline" as="span" />
            </p>
            <SocialLinks variant="footer" className="mt-5" />
          </div>
          <div className="grid grid-cols-2 gap-6 text-sm">
            <div className="flex flex-col gap-2">
              <span className="text-white font-semibold mb-1"><EditableText k="footer.explore" as="span" /></span>
              {vis("about") && <Link to="/about" className="hover:text-white transition-colors"><EditableText k="footer.about" as="span" /></Link>}
              {vis("programs") && <a href="/#programs" className="hover:text-white transition-colors"><EditableText k="nav.programs" as="span" /></a>}
              {vis("events") && <a href="/#events" className="hover:text-white transition-colors"><EditableText k="nav.events" as="span" /></a>}
              {vis("gallery") && <a href="/#gallery" className="hover:text-white transition-colors"><EditableText k="nav.gallery" as="span" /></a>}
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-white font-semibold mb-1"><EditableText k="footer.support" as="span" /></span>
              {vis("donate") && <a href="/#donate" className="hover:text-white transition-colors"><EditableText k="nav.donate" as="span" /></a>}
              {vis("contact") && <a href="/#contact" className="hover:text-white transition-colors"><EditableText k="nav.contact" as="span" /></a>}
              {vis("footer_admin") && <Link to="/login" data-testid="footer-admin-link" className="hover:text-white transition-colors"><EditableText k="footer.admin" as="span" /></Link>}
            </div>
          </div>
          <div className="text-sm">
            <span className="text-white font-semibold"><EditableText k="footer.visit" as="span" /></span>
            <p className="mt-3 leading-relaxed"><EditableText k="footer.address" as="span" /><br /><EditableText k="footer.country" as="span" /></p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs">
          <span>© {new Date().getFullYear()} {siteName}. {t("footer.rights")}</span>
          <span><EditableText k="footer.built" as="span" /></span>
        </div>
      </div>
    </footer>
  );
}
